import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISurveyQuestionItemCustom, ISurveyQuestionItemDTO } from '../../major_explorer_interface';

export class MetaRankingQuestionFunction {
  constructor(
    private saveMetaRankingCommand: ICommand,
    private loadMetaRankingCommand: ICommand,
    private deleteMetaRankingCommand: ICommand,
    private myIntakeHistoryModel: any,
    private ItemPresenterEnum: any,
    private $q: ng.IQService
  ) {}

  initialize(item: ISurveyQuestionItemDTO): void {
    item.custom = {} as ISurveyQuestionItemCustom;
    this.loadMetaRankingCommand().then((model: ISurveyQuestionItemCustom) => {
      item.custom = model;
      this.myIntakeHistoryModel.update(this.ItemPresenterEnum.METARANKING.key, model.toList);
    });
  }

  validate(item: ISurveyQuestionItemDTO): boolean {
    let itemData;
    let noItemsToSelect;
    let toList;
    let toListSize;
    let maxList;

    if (!item.custom) {
      return false;
    }

    itemData = item.custom;
    noItemsToSelect = _4.isEmpty(itemData.fromList);
    toList = itemData.toList;
    toListSize = _4.size(toList);
    maxList = itemData._max;

    if (noItemsToSelect) {
      return true;
    } else {
      return !_4.isEmpty(toList) && toListSize <= maxList && toListSize >= 1;
    }
  }

  validate_itemList(item: ISurveyQuestionItemDTO): boolean {
    let maxList;
    let selectedList;

    maxList = item.custom._max;

    selectedList = _4.filter(item.custom.masterList, (element: any) => {
      return element._isRanked;
    });

    return !_4.isEmpty(selectedList) && selectedList.length <= maxList;
  }

  item_onChange(item: ISurveyQuestionItemDTO): void {
    item.custom.toList = _4.filter(item.custom.toList, 'id');
    item.custom.fromList = _4.filter(item.custom.fromList, 'id');

    this.myIntakeHistoryModel.update(this.ItemPresenterEnum.METARANKING.key, item.custom.toList);

    this.saveMetaRankingCommand(item.custom.toList);
    this.deleteMetaRankingCommand(item.custom.fromList);
  }

  updateItemList(item: ISurveyQuestionItemDTO): void {
    item.custom.toList = _4.filter(item.custom.masterList, (element: any) => {
      return element._isRanked;
    });
    item.custom.fromList = _4.filter(item.custom.masterList, (element: any) => {
      return !element._isRanked;
    });
  }

  itemList_onChange(item: ISurveyQuestionItemDTO) {
    const deferred = this.$q.defer();
    this.updateItemList(item);

    this.myIntakeHistoryModel.update(this.ItemPresenterEnum.METARANKING.key, item.custom.toList);

    this.deleteMetaRankingCommand(item.custom.fromList).then(() => {
      this.saveMetaRankingCommand(item.custom.toList).then(() => {
        deferred.resolve();
      });
    });

    return deferred.promise;
  }
}

angular.module('major-explorer-data').service('metaRankingQuestionFn', MetaRankingQuestionFunction);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/functions/metaranking_fn.ts